// Helpers de exibicao compartilhados entre a lista de convidados e o leitor QR.

export const CORES = {
  navy: "#0b2a45",
  navyClaro: "#123a5c",
  fundo: "#f1f3f6",
  borda: "#e2e6ec",
  texto: "#14212e",
  textoSuave: "#5c6b7a",
  verde: "#1f8a4c",
  verdeFundo: "#e6f4ec",
  azul: "#2f7fd1",
  ambar: "#d99a1a",
  ambarFundo: "#fdf3dc",
  vermelho: "#c0392b",
  vermelhoFundo: "#fdecea",
};

export const iniciais = (nome = "") => {
  const partes = nome.trim().split(/\s+/).filter(Boolean);
  if (partes.length === 0) return "?";
  const primeira = partes[0][0];
  const ultima = partes.length > 1 ? partes[partes.length - 1][0] : "";
  return `${primeira}${ultima}`.toUpperCase();
};

export const horaCurta = (data) => {
  if (!data) return "";
  const d = new Date(data);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });
};

export const formatarTelefone = (valor) => {
  const digitos = String(valor || "").replace(/\D/g, "");
  if (digitos.length === 11) return `(${digitos.slice(0, 2)}) ${digitos.slice(2, 7)}-${digitos.slice(7)}`;
  if (digitos.length === 10) return `(${digitos.slice(0, 2)}) ${digitos.slice(2, 6)}-${digitos.slice(6)}`;
  return valor || "";
};

// Subtitulo debaixo do nome: "Cargo · Instituicao" (o que existir).
export const subtituloConvidado = (p) => {
  const instituicao = p.instituicao === "Outros" ? p.instituicao_outro : p.instituicao;
  return [p.cargo, instituicao].filter(Boolean).join(" · ");
};

export const statusConfirmacao = (p) => (p.confirmar_presenca ? "confirmado" : "pendente");

export const ehPresente = (p) => p.presenca === 1 || p.presenca === true;

// Busca sem acento/maiuscula — nome, distrital, municipio e telefone (so digitos).
export const normalizar = (texto) =>
  String(texto || "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase();

export const combinaBusca = (p, nomeDistrital, termo) => {
  const t = normalizar(termo).trim();
  if (!t) return true;
  const digitosTermo = t.replace(/\D/g, "");
  const campos = [p.nome, nomeDistrital, `distrital ${nomeDistrital}`, p.municipio, p.email];
  if (campos.some((c) => normalizar(c).includes(t))) return true;
  return digitosTermo.length >= 4 && String(p.telefone || "").replace(/\D/g, "").includes(digitosTermo);
};
